export const env = __ENV__
